export const theme = {
	primary: "#F4F0E2",
	secondary: "#545c52",
	tertiary: "#c4745a",
	quaternary: "#dedbd2",
	darkGray: "#5d5d5d",
	pastelBlue: {
		lighter: "#ced6db",
		light: "#c9d1d7",
		DEFAULT: "#6b8394",
		dark: "#3b4952",
		darker: "#242c31",
	},
	pastelGreen: {
		lighter: "#cfdad2",
		light: "#b0c1b5",
		DEFAULT: "#708f79",
		dark: "#3e4f43",
		darker: "#253028",
	},
	pastelPurple: {
		lighter: "#d7d0d9",
		light: "#bcb1c0",
		DEFAULT: "#86728d",
		dark: "#4b3f4e",
		darker: "#2d262f",
	},
	prussianBlue: {
		lighter: "#cfd4da",
		light: "#afb7c1",
		DEFAULT: "#6f7d90",
		dark: "#3e4650",
		darker: "#252a30",
	},
};
